export const radioButtonLabelClassName = "js-e2e-radioButton-label";
